import React, { useEffect } from 'react';
import styles from './styles.module.scss';
import { FaRegUser } from 'react-icons/fa';

import { GestaoAmeiFrame } from '@sebrae/gestao-amei-frame';
// import axios, { getEnv } from '../../services/api';

export default function GestaoUsuario() {
  const getUrl = () => {
    let url = '';
    if (
      window.location.href === 'https://localhost:3000/gestao-usuarios' ||
      window.location.href ===
        'https://na-palma-adm-frontend.homologacao.sebrae.com.br/gestao-usuarios'
    ) {
      url = 'https://gestao-amei-frontend.homologacao.sebrae.com.br';
    } else if (
      window.location.href ===
      'https://adm-appsebrae.sebrae.com.br/gestao-usuarios'
    ) {
      url = 'https://gestao-amei.sebrae.com.br';
    }

    console.log(url);
    return url;
  };

  useEffect(() => {
    getUrl();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FaRegUser size={'40px'} color="#ffffff" />
        <p>Gestão de usuários</p>
      </div>

      <div className={styles.content}>
        <GestaoAmeiFrame
          // url="https://gestao-amei-frontend.homologacao.sebrae.com.br"
          // url="https://gestao-amei.sebrae.com.br"
          url={`${getUrl()}`}
          realm="externo"
          module="role-map"
          roleMapOptions={{
            clientId: 'na-palma-web',
          }}
          roleMapEvent={{
            onNotification: (event) => {
              console.log('Oia, recebi uma notificação do iframe', event);
              alert(event.message);
            },
          }}
        />
      </div>
    </div>
  );
}
